'use client';

import { Chip, Skeleton } from '@common/components';

interface FilterChipRadioGroupProps<T extends string | number> {
  options: { value: T; label: string }[];
  selectedValue: T | null;
  onSelect: (value: T | null) => void;
  isLoading?: boolean;
  skeletonCount?: number;
}

const SKELETON_CHIP_WIDTHS = [60, 80, 72, 92, 64];

export function FilterChipRadioGroup<T extends string | number>({
  options,
  selectedValue,
  onSelect,
  isLoading = false,
  skeletonCount = 5,
}: FilterChipRadioGroupProps<T>) {
  if (isLoading) {
    /* 실제 <Chip className="px-16 py-8 typo-body4 border-1"> ≈ 39px */
    return (
      <div className="flex flex-wrap gap-8">
        {Array.from({ length: skeletonCount }, (_, index) => (
          <Skeleton
            key={index}
            className="h-39 rounded-pill"
            style={{
              width: `${SKELETON_CHIP_WIDTHS[index % SKELETON_CHIP_WIDTHS.length]}px`,
            }}
          />
        ))}
      </div>
    );
  }

  if (options.length < 1) return null;

  return (
    <div className="flex flex-wrap gap-8">
      {options.map((option) => (
        <Chip
          key={String(option.value)}
          checked={selectedValue === option.value}
          onCheckedChange={() =>
            onSelect(selectedValue === option.value ? null : option.value)
          }
          theme="primary-line"
          className="px-16 py-8 typo-body4"
        >
          {option.label}
        </Chip>
      ))}
    </div>
  );
}
